export enum TypeNotificationEnum {
  Comunicados = 'mensagem',
  Notificacoes = 'notificacao',
  PesquisaSatisfacao = 'pesquisa_satisf',
  SaudeOnline = 'saude_online',
  Todos = 'todos'
}